import { useEffect, useState } from 'react'
import { Stack, Text } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { AppModal, ActionButton } from '@/components/ui'
import { api, ApiError } from '@/lib/api'

type Props = {
  opened: boolean
  onClose: () => void
  ticketIds: string[]
  onApplied: () => void
}

export function TicketsBulkAiReleaseModal({ opened, onClose, ticketIds, onApplied }: Props) {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!opened) setLoading(false)
  }, [opened])

  const apply = async () => {
    if (!ticketIds.length) {
      showNotification({ title: 'Нет выбора', message: 'Выберите хотя бы одно обращение.', color: 'yellow' })
      return
    }
    setLoading(true)
    try {
      const res = await api.ticketsBulkUpdate({
        ticket_ids: ticketIds,
        status: 'open',
        assigned_to_id: null,
      })
      showNotification({
        title: 'Назначение снято',
        message: `Обращений переведено в не назначенные: ${res.updated}.`,
        color: 'green',
      })
      onApplied()
      onClose()
    } catch (e) {
      showNotification({
        title: 'Ошибка',
        message: e instanceof ApiError ? e.message : 'Не удалось снять назначение с Мозгобота',
        color: 'red',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <AppModal
      opened={opened}
      onClose={onClose}
      title="Снять с Мозгобота"
      size="md"
      footer={
        <>
          <ActionButton action="cancel" onClick={onClose} disabled={loading} />
          <ActionButton
            action="apply"
            label="Снять назначение"
            onClick={() => void apply()}
            loading={loading}
          />
        </>
      }
    >
      <Stack gap="sm">
        <Text size="sm">Выбрано обращений: {ticketIds.length}</Text>
        <Text size="sm" c="dimmed">
          Обращения будут сняты с Мозгобота, переведены в статус «Открыто» и попадут в блок
          «Не назначенные».
        </Text>
      </Stack>
    </AppModal>
  )
}
